module.exports = __webpack_public_path__ + "img/message6.4fb4307c.png";